import type { FC } from 'react';

import { IconButton, Tooltip } from '@mui/material';
import { clsx } from 'clsx';

import DoubleChevronIcon from 'shared/ui/icons/double-chevron.svg?react';

type SidebarToggleProps = {
  isPinned: boolean;
  className?: string;
  onToggle: VoidFunction;
};

export const SidebarToggle: FC<SidebarToggleProps> = ({ isPinned, className, onToggle }) => (
  <Tooltip placement="right" title={isPinned ? 'Collapse menu' : 'Keep menu expanded'}>
    <IconButton
      aria-label={isPinned ? 'Collapse menu' : 'Keep menu expanded'}
      // No resting background — the chevron sits directly on the nav. IconButton is circular by
      // default, so the radius has to be set rather than just left unset.
      className={clsx('h-8 w-8 rounded-lg p-0 text-white hover:bg-white/10', className)}
      data-testid="sidebar-toggle"
      onClick={onToggle}
    >
      <DoubleChevronIcon className={clsx('h-5 w-5', isPinned && 'rotate-180')} />
    </IconButton>
  </Tooltip>
);
